import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { FilterValues } from '@/domains/Groups/constants/FilterValues';
import { SortValues } from '@/domains/Groups/constants/SortValues';
import { GroupPage } from '@/domains/Groups/GroupPage';
import discoverService from '@/services/discoverService';
import { Group as GroupType } from '@/types/Content/Group';

interface GroupProps {
  slug: string;
  group: GroupType;
  filter: FilterValues;
  sortBy: SortValues;
}

function Group({ group, filter, sortBy, slug }: GroupProps): JSX.Element {
  return (
    <GroupPage groupProps={group} filter={filter} sortBy={sortBy} slug={slug} />
  );
}

export async function getServerSideProps({
  query,
}: GetServerSidePropsContext): Promise<GetServerSidePropsResult<GroupProps>> {
  const { slug, filter = null, sortBy = null } = query as {
    slug: string;
    filter: FilterValues;
    sortBy: SortValues;
  };

  const group = await discoverService.getGroup(
    slug as string,
    null,
    filter ? (Array.isArray(filter) ? filter : [filter]) : null,
    (sortBy || SortValues.TRENDING) === SortValues.TRENDING,
  );
  return { props: { group, filter, sortBy, slug } };
}

export default Group;
